export const webPages = {
  championshipPage: 'championship-page',
  championshipsPage: 'championships-page',
  customPage: 'custom-page',
  notFoundPage: 'not-found-page',
  profilePage: 'profile-page',
  regattaPage: 'regatta-page',
  regattasPage: 'regattas-page',
  regionsPage: 'regions-page',
} as const;

export const webSections: Record<
typeof webPages[keyof typeof webPages],
Record<string, string>
> = {
  [webPages.championshipPage]: {
    description: 'description',
    details: 'details',
    documents: 'documents',
    regattas: 'regattas',
    results: 'results',
    sponsors: 'sponsors',
  },
  [webPages.championshipsPage]: {
    banners: 'banners',
    championships: 'championships',
  },
  [webPages.customPage]: {
    details: 'details',
    notFound: 'not-found',
  },
  [webPages.notFoundPage]: {
    notFound: 'not-found',
  },
  [webPages.profilePage]: {
    advertisements: 'advertisements',
    anauthenticate: 'anauthenticate',
    regattaEntries: 'regattas-entries',
    regattaNotifications: 'regatta-notifications',
    session: 'session',
  },
  [webPages.regattaPage]: {
    advertisements: 'advertisements',
    boatRent: 'boat-rent',
    championships: 'championships',
    contacts: 'contacts',
    description: 'description',
    details: 'details',
    documents: 'documents',
    entries: 'entries',
    messages: 'messages',
    protests: 'protests',
    registration: 'registration',
    results: 'results',
    resultsOverall: 'results-overall',
    schedule: 'schedule',
    sponsors: 'sponsors',
    tracker: 'tracker',
  },
  [webPages.regattasPage]: {
    advertisements: 'advertisements',
    banners: 'banners',
    entries: 'entries',
    regattas: 'regattas',
  },
  [webPages.regionsPage]: {
    list: 'list',
  },
};

export const adminPages = {
  adminAdminAccessTokensPage: 'admin-admin-access-tokens-page',
  adminAdminSocialUsersPage: 'admin-admin-social-users-page',
  adminAdminsPage: 'admin-admins-page',
  adminAdvertisementsPage: 'admin-advertisements-page',
  adminBannersPage: 'admin-buttons-page',
  adminCrewmemberAccessTokensPage: 'admin-crewmember-access-tokens-page',
  adminCrewmemberSocialUsersPage: 'admin-crewmember-social-users-page',
  adminCrewmembersPage: 'admin-crewmembers-page',
  adminCustomPagesPage: 'admin-custom-pages-page',
  adminDocumentsPage: 'admin-documents-page',
  adminEntriesPage: 'admin-entries-page',
  adminEntriesUnmatchedPage: 'admin-entries-unmatched-page',
  adminEntryRatingsPage: 'admin-entry-ratings-page',
  adminGroupsPage: 'admin-groups-page',
  adminRatingsPage: 'admin-ratings-page',
  adminRegattaNotificationCrewmembersPage: 'admin-regatta-notification-crewmembers-page',
  adminRegattaNotificationsPage: 'admin-regatta-notifications-page',
  adminRegattaPaymentDiscountsPage: 'admin-regatta-payment-discounts-page',
  adminRegattaPaymentsPage: 'admin-regatta-payments-page',
  adminRegionSeasonsPage: 'admin-region-seasons-page',
  adminRegionsPage: 'admin-regions-page',
  championshipPage: 'championship-page',
  championshipsPage: 'championships-page',
  loginPage: 'login-page',
  notFoundPage: 'not-found-page',
  profilePage: 'profile-page',
  regattaBoardPage: 'regatta-board-page',
  regattaCoursePage: 'regatta-course-page',
  regattaCoursesPage: 'regatta-courses-page',
  regattaEntriesPage: 'regatta-entries-page',
  regattaEntryRatingsPage: 'regatta-entry-ratings-page',
  regattaInfoPage: 'regatta-info-page',
  regattaLogsPage: 'regatta-logs-page',
  regattaResultDiplomasPage: 'regatta-result-diplomas-page',
  regattaResultOverallsPage: 'regatta-result-overalls-page',
  regattaResultsPage: 'regatta-results-page',
  regattaSettingsPage: 'regatta-settings-page',
  regattasPage: 'regattas-page',
} as const;

export const adminSections: Record<
typeof adminPages[keyof typeof adminPages],
Record<string, string>
> = {
  [adminPages.adminAdminAccessTokensPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminAdminSocialUsersPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminAdminsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminAdvertisementsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminBannersPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminCrewmemberAccessTokensPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminCrewmemberSocialUsersPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminCrewmembersPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminCustomPagesPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminDocumentsPage]: {
    championshipDocumentsList: 'championship-documents-list',
    header: 'header',
    regattaDocumentsList: 'regatta-documents-list',
  },
  [adminPages.adminEntriesPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminEntriesUnmatchedPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminEntryRatingsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminGroupsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminRatingsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminRegattaNotificationCrewmembersPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminRegattaNotificationsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminRegattaPaymentDiscountsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminRegattaPaymentsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminRegionSeasonsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.adminRegionsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.championshipPage]: {
    admins: 'admins',
    description: 'description',
    documents: 'documents',
    header: 'header',
    regattas: 'regattas',
    results: 'results',
    settings: 'settings',
    sponsors: 'sponsors',
  },
  [adminPages.championshipsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.loginPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.notFoundPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.profilePage]: {
    header: 'header',
    invoiceDetails: 'invoice-details',
    invoices: 'invoices',
    settings: 'settings',
    socialUsers: 'social-users',
  },
  [adminPages.regattaBoardPage]: {
    documents: 'documents',
    messages: 'messages',
    protests: 'protests',
  },
  [adminPages.regattaCoursePage]: {
    header: 'header',
    list: 'list',
    map: 'map',
  },
  [adminPages.regattaCoursesPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.regattaEntriesPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.regattaEntryRatingsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.regattaInfoPage]: {
    boatRents: 'boat-rents',
    schedule: 'schedule',
    sponsors: 'sponsors',
  },
  [adminPages.regattaLogsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.regattaResultDiplomasPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.regattaResultOverallsPage]: {
    header: 'header',
    list: 'list',
  },
  [adminPages.regattaResultsPage]: {
    header: 'header',
    tables: 'tables',
    tiles: 'tiles',
  },
  [adminPages.regattaSettingsPage]: {
    admins: 'admins',
    checks: 'checks',
    contacts: 'contacts',
    description: 'description',
    groups: 'groups',
    registration: 'registration',
    requirements: 'requirements',
    settings: 'settings',
    status: 'status',
  },
  [adminPages.regattasPage]: {
    adminProposes: 'admin-proposes',
    adminRequests: 'admin-requests',
    header: 'header',
    list: 'list',
  },
};
